<template>
  <div>
    <div class="full-header">
      <div class="full-header-wrapper">
        <p class="title">{{ Translator('soprasolar.project.demand.title', { number: id }) }}</p>
        <a :href="'/api/project-applications/' + projectApplicationToken + '/excel'" class="demand-button" target="_blank" rel="noopener noreferrer" v-if="isAdmin" :disabled="isLoading">
          {{ Translator("soprasolar.project.demand.download") }}
          <i class="ic ic-save" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </a>
      </div>
    </div>
    <div class="project-wrapper">
      <div class="project-container-inner">
        <resume />
        <a :href="solutionsPage" class="demand-button" v-if="!isAdmin">{{ Translator('soprasolar.project.demand.solutions_button') }}</a>
      </div>
      <div>
        <user />
        <div v-if="contacts && contacts.length > 0" class="project-contact">
          <p class="project-subtitle">{{ Translator('soprasolar.project.demand.contacts') }}</p>
          <contact v-for="contact, index in contacts" :key="index" :user="contact" />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
.full-header {
  @include fullSize;
  @include vertical-spacing-bottom(.5);
  @include vertical-spacing-inner;
  background-color: $blue-light;
  .full-header-wrapper {
    @include wrapper;
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
  .title {
    @include title(2);
    margin-bottom: 0;
  }
}
.demand-button {
  @include cta;
}
.project-container-inner {
  @include tablet {
    max-width: calc(100% - 300px);
  }
}
.project-wrapper {
  width: 100%;
  display: flex;
  @include mobile {
    flex-direction: column;
    gap: rem(40);
  }
  @include tablet {
    align-items: flex-start;
    justify-content: space-between;
    gap: rem(50);
  }
  .demand-button {
    margin-top: rem(30);
  }
  .project-contact {
    width: 100%;
    padding: rem(15) rem(30);
  }
}
</style>
<script>
import AppControlService from '@/soprasolar-project/services/AppControl';
import Resume from '@/soprasolar-project/components/Resume';
import User from '@/soprasolar-project/components/User';
import Contact from '@/soprasolar-project/components/Contact';

export default {
  name: 'demand',
  components: {
    Resume,
    User,
    Contact
  },
  data () {
    return {
      id: AppControlService.id,
      datas: AppControlService.datas,
      contacts: AppControlService.contacts,
      isLoading: false,
      solutionsPage: window.solutionsPageLink,
      projectApplicationToken: null
    }
  },

  computed: {
    isAdmin: () => {
      return AppControlService.isAdmin;
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    this.projectApplicationToken = params.get("token");
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {},

  methods: {
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      this.contacts = AppControlService.contacts;
    },
  }
};
</script>